import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  dialogWhiteSpace: {
    whiteSpace: 'pre-wrap',
  },
  stringTextTransform: {
    textTransform: 'none',
  },
}))

export default useStyles
